var _excluded = ["text", "to", "href", "title", "openInNewTab", "isInactive", "onClick", "onKeyDown", "onMouseEnter"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import styled, { css } from "styled-components";
import OnColorContext from "../../../../../../../../contexts/OnColorContext";
import useBreakpoint from "../../../../../../../../hooks/useBreakpoint";
import breakpoint from "../../../../../../../../utils/breakpoint";
import getIconColor from "../../../../../../../../utils/getIconColor";
import getTextColor from "../../../../../../../../utils/getTextColor";
import setSafeHoverStyles from "../../../../../../../../utils/setSafeHoverStyles";
import space from "../../../../../../../../utils/space";
import transition from "../../../../../../../../utils/transition";
import { cssTextAtm } from "../../../../../../../atoms/TextAtm/TextAtm.styled";
import ButtonQuark from "../../../../../../../quarks/Button";
import LinkQuark from "../../../../../../../quarks/Link";
import { hugeBreakpointValue } from "../../../../settings";
var ArrowSvg = function ArrowSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M6 0 4.943 1.058 9.128 5.25H0v1.5h9.128l-4.185 4.193L6 12l6-6-6-6z"
  }));
};
ArrowSvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12"
};
var emphasis = "high";
export var paddingHorizontalSpaceOnHugeScreen = 2.5;
var baseStyles = function baseStyles(onColor, isInactive) {
  return css(["", ";", ";display:flex;align-items:center;justify-content:space-between;padding:", " 0;text-transform:uppercase;", ";", "{", ";}", "{padding:0 ", ";}"], transition("color"), cssTextAtm({
    typography: "xsmall3",
    onColor: onColor,
    emphasis: emphasis
  }), space(2.5), isInactive && css(["color:", " !important;"], function (props) {
    return getTextColor(props.theme, onColor, emphasis, "hover");
  }), breakpoint("small", hugeBreakpointValue), function (props) {
    return setSafeHoverStyles(css(["color:", ";"], getTextColor(props.theme, onColor, emphasis, "hover")));
  }, breakpoint(hugeBreakpointValue), space(paddingHorizontalSpaceOnHugeScreen));
};
var Link = styled(LinkQuark).withConfig({
  componentId: "sc-1wit6bm-0"
})(function (_ref) {
  var $isInactive = _ref.$isInactive,
    $onColor = _ref.$onColor;
  return css(["", ";text-decoration:none;"], baseStyles($onColor, $isInactive));
});
var Arrow = styled(ArrowSvg).withConfig({
  componentId: "sc-1wit6bm-1"
})(function (_ref2) {
  var $onColor = _ref2.$onColor,
    theme = _ref2.theme;
  return css(["", ";fill:", ";"], transition("transform"), getIconColor(theme, $onColor, emphasis));
});
var Button = styled(ButtonQuark).withConfig({
  componentId: "sc-1wit6bm-2"
})(function (_ref3) {
  var $isInactive = _ref3.$isInactive,
    $onColor = _ref3.$onColor,
    $isHugeScreen = _ref3.$isHugeScreen;
  return css(["", ";width:100%;", ";", ""], baseStyles($onColor, $isInactive), setSafeHoverStyles(css(["", "{transform:translateX(", ");}"], Arrow, space(1))), $isHugeScreen ? css(["&:focus:not(:focus-visible){outline:none;}"]) : null);
});
function NavigationCtaAtm(_ref4) {
  var text = _ref4.text,
    to = _ref4.to,
    href = _ref4.href,
    title = _ref4.title,
    openInNewTab = _ref4.openInNewTab,
    isInactive = _ref4.isInactive,
    onClick = _ref4.onClick,
    onKeyDown = _ref4.onKeyDown,
    onMouseEnter = _ref4.onMouseEnter,
    restProps = _objectWithoutProperties(_ref4, _excluded);
  var onColor = useContext(OnColorContext);
  var isHugeScreen = useBreakpoint(hugeBreakpointValue);
  if (to || href) {
    return /*#__PURE__*/React.createElement(Link, _extends({
      to: to,
      href: href,
      title: title,
      openInNewTab: openInNewTab,
      onClick: onClick,
      onMouseEnter: onMouseEnter,
      $isInactive: !!isInactive,
      $onColor: onColor
    }, restProps), text);
  }
  return /*#__PURE__*/React.createElement(Button, _extends({
    onClick: onClick,
    onKeyDown: onKeyDown,
    onMouseEnter: onMouseEnter,
    $isInactive: !!isInactive,
    $onColor: onColor,
    $isHugeScreen: isHugeScreen,
    tabIndex: 0
  }, restProps), text, !isHugeScreen && /*#__PURE__*/React.createElement(Arrow, {
    $onColor: onColor
  }));
}
export default NavigationCtaAtm;